export interface BackgroundAnimationData {
    backgroundId: string;
    animationName?: string;
    skinName?: string;
}

export interface CommonConfig {
    backgroundAnimation?: BackgroundAnimationData[];
}